const RELOAD_KEY = "ow-chunk-reload-at";
const RELOAD_WINDOW_MS = 60000;
const CHUNK_ERROR_PATTERNS = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
  "Unable to preload CSS",
];

let reloadPending = false;

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};

const readLastReload = (storage) => {
  try {
    return Number(storage?.getItem(RELOAD_KEY)) || 0;
  } catch (e) {
    return 0;
  }
};

export const isChunkLoadError = (error) => {
  const text = `${error?.name ?? ""} ${error?.message ?? ""}`;
  return CHUNK_ERROR_PATTERNS.some((pattern) => text.includes(pattern));
};

export const isReloadPending = () => reloadPending;

export function reloadOnceForNewBuild({
  storage = getSessionStorage(),
  now = Date.now(),
  reload = () => window.location.reload(),
} = {}) {
  if (reloadPending) return true;
  if (now - readLastReload(storage) < RELOAD_WINDOW_MS) return false;
  try {
    storage?.setItem(RELOAD_KEY, String(now));
  } catch (e) {}
  reloadPending = true;
  reload();
  return true;
}
